module.exports = __webpack_public_path__ + "img/Dinotastisch.43cda0ba.svg";